(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bjj-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function all(sel, root) {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function initPdp(root) {
      if (root.__bjjPdp) return;
      root.__bjjPdp = true;

      var holder = root.querySelector('[data-bjj-variants]');
      var variants = [];
      if (holder) {
        try { variants = JSON.parse(holder.textContent); } catch (err) { variants = []; }
      }
      var idInput = root.querySelector('[data-bjj-variant-id]');
      var section = root.closest('.shopify-section') || document;
      var priceEls = all('[data-bjj-price]', section);
      var compareEls = all('[data-bjj-compare]', section);
      var addBtns = all('[data-bjj-add]', section);

      function chosen() {
        var opts = [];
        all('[data-bjj-opt]', root).forEach(function (input) {
          if (!input.checked) return;
          opts[parseInt(input.getAttribute('data-index'), 10) || 0] = input.value;
        });
        return opts;
      }

      function findVariant(opts) {
        if (!opts.length) return variants[0] || null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function update() {
        var v = findVariant(chosen());
        if (idInput) idInput.value = v ? v.id : '';
        if (v) {
          priceEls.forEach(function (el) { el.textContent = v.price; });
          compareEls.forEach(function (el) {
            if (v.on_sale) { el.textContent = v.compare_at; el.hidden = false; }
            else { el.hidden = true; }
          });
        }
        addBtns.forEach(function (btn) {
          var label = btn.querySelector('[data-bjj-add-text]');
          var text;
          if (!v) { text = btn.getAttribute('data-unavailable-label'); }
          else if (!v.available) { text = btn.getAttribute('data-soldout-label'); }
          else { text = btn.getAttribute('data-add-label'); }
          btn.disabled = !v || !v.available;
          if (label && text) label.textContent = text;
        });
        if (v && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (err) { /* older browsers keep the current url */ }
        }
      }

      root.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bjj-opt')) update();
      });
      update();
    }

    function initBar(bar) {
      if (bar.__bjjBar) return;
      bar.__bjjBar = true;
      var at = parseInt(bar.getAttribute('data-bjj-buybar'), 10) || 900;
      function onScroll() {
        bar.classList.toggle('is-in', window.scrollY > at);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function init() {
      all('[data-bjj-pdp]').forEach(initPdp);
      all('[data-bjj-buybar]').forEach(initBar);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // BJJ — cart badge pulse on item add
  document.addEventListener('cart:add', function() {
    var badge = document.querySelector('.cart-count-bubble');
    if (!badge) return;
    badge.classList.remove('bjj-pulse');
    void badge.offsetWidth;
    badge.classList.add('bjj-pulse');
    badge.addEventListener('animationend', function() {
      badge.classList.remove('bjj-pulse');
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();
})();
